module.exports = __webpack_public_path__ + "static/media/ss_logo.f02902fd.png";